// extracted by mini-css-extract-plugin
module.exports = {"button":"CountryButton__button","inactive":"CountryButton__inactive","active":"CountryButton__active","flag":"CountryButton__flag"};